// extracted by mini-css-extract-plugin
module.exports = {"TierLimits__table__2lGeI":"TierLimits__table__2lGeI","TierLimits__disclaimer__151pR":"TierLimits__disclaimer__151pR"};